/* eslint-disable react/jsx-props-no-spreading */
import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Route, Redirect } from 'react-router-dom';
import MyContext from '../services/context';
import { grantedForRole } from '../utils/misc';

interface Props {
  component: any;
  exact: boolean;
  path: string;
  roles?: string[];
}
export default function RestrictedRoute({ component, roles, ...rest }: Props): JSX.Element {
  const context = useContext(MyContext);
  return (
    <Route
      {...rest}
      render={() => {
        if (context.user?.isAuthenticated !== true) {
          return <Redirect to="/login" />;
        }
        const granted = grantedForRole(roles, context.user?.role);

        if (!granted) {
          return <Redirect to="/403" />;
        }

        return component;
      }}
    />
  );
}

RestrictedRoute.propTypes = {
  component: PropTypes.node.isRequired,
};
